import { render, staticRenderFns } from "./PressItem.vue?vue&type=template&id=5aaff70b&scoped=true&"
import script from "./PressItem.vue?vue&type=script&lang=js&"
export * from "./PressItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaff70b",
  null
  
)

export default component.exports